import { css, html } from 'lit';

export function _formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
        hour12: false,
    };
    return date.toLocaleDateString('en-GB', options).replace(',', '') + ' UTC';
}

export function getTimeThresholds() {
    return {
        oneHour: 1 * 60 * 60 * 1000,
        twelveHours: 12 * 60 * 60 * 1000,
        twentyFourHours: 24 * 60 * 60 * 1000,
        thirtySixHours: 36 * 60 * 60 * 1000,
        fortyEightHours: 48 * 60 * 60 * 1000,
    };
}

export function generateMessage(hours: number) {
    if(hours === 1){
        hours = 0;
    }
    return html`
        <div>
            Please select a Star Route if available or create your own route
            and submit it at your earliest convenience. There are ${hours}
            hours to ETD, and your voyage plan may be subject to weather
            routing.
        </div>
    `;
}


export const styles = css`
    .title-style {
        font-family: MaerskText;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
    }
    .para-style {
        font-family: MaerskText;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }
    .icon-styles {
        display: flex;
        font-size: 20px;
        padding-top: 2px;
    }
    .icon-container{
        display:flex;
        justify-content:center;
    }
    .message-styles {
        padding-top: 12px;
    }
    .closeButton {
        position: relative;
        display: flex;
        padding: 0;
        background: none;
        border: none;
        outline: none;
        cursor: pointer !important;
        z-index: 9999;
        fill: var(--neutrals-grey-04, grey);
    }
    .closeButton > svg {
        display: block;
        width: 10px;
    }
    .grid-container {
        z-index: 99;
        background-color: #b5e0f5;
        box-shadow: 4px 4px 8px 2px #00000040;
        border-radius: 4px;
        display: grid;
        grid-template-columns: auto 1fr auto;
        gap: 12px;
        width: 97%;
        height: auto;
        padding-top: 12px;
        padding-bottom: 12px;
        padding-left: 12px;
        padding-right: 12px;
        margin-bottom:10px;
    }
`